import "./StoreSelectionLocationModal.scss";

import * as React from "react";

import { Button, Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

type Props = {
    storeName?: string | null;
    onHide: () => void;
    onAccept: () => void;
    onCancel: () => void;
    shouldShow: boolean;
};

export function StoreSelectionLocationModal(props: Props) {
    return (
        <Modal className="sd-geolocation-modal" show={props.shouldShow} onHide={props.onHide}>
            <Modal.Header className="sd-geolocation-modal-header" closeButton />
            <Modal.Body className="container-fluid">
                <h3 className="sd-geolocation-text-header">
                    <FormattedMessage id={"SD_GEOLOCATION_MODAL_HEADER"} />
                </h3>
                <p className="sd-geolocation-text-body">
                    <FormattedMessage id={"SD_GEOLOCATION_MODAL_TEXT"} values={{ storeName: props.storeName }} />
                </p>
                <Button className="sd-geolocation-accept-button" bsStyle="primary" onClick={props.onAccept}>
                    <FormattedMessage id={"SD_GEOLOCATION_MODAL_AGREE"} />
                </Button>
                <Button className="sd-geolocation-cancel-button" bsStyle="link" onClick={props.onCancel}>
                    <FormattedMessage id={"SD_GEOLOCATION_MODAL_CANCEL"} />
                </Button>
            </Modal.Body>
        </Modal>
    );
}
